// @flow

/**
 * Partially masks an email address for display: reveals the first character,
 * the character at the midpoint, and the last character before the @.
 * Everything else becomes '*'. The domain is kept in full.
 * Examples:
 *   utilisateur@example.com → u****s****r@example.com
 *   abcde@x.com             → a*c*e@x.com
 *   ab@x.com                → **@x.com  (≤2 chars: mask all)
 */
export const maskEmail = (email: string): string => {
  const atIndex = email.indexOf('@');
  if (atIndex <= 0) return email;
  const local = email.slice(0, atIndex);
  const domain = email.slice(atIndex);

  const len = local.length;

  // If the local part is too short for 3 distinct positions, mask everything.
  if (len <= 2) {
    return '*'.repeat(len) + domain;
  }

  const midIndex = Math.floor((len - 1) / 2);

  let masked = '';
  for (let i = 0; i < len; i++) {
    if (i === 0 || i === midIndex || i === len - 1) {
      masked += local[i];
    } else {
      masked += '*';
    }
  }

  return masked + domain;
};
